import dayjs from 'dayjs';
import { Checkbox } from '../../../../../../../../components/checkbox/checkbox';
import { Label } from '../../../../../../../../components/label/label';
import { DatePicker } from '../../../../../../../../features/date-time/date-picker/date-picker';
import { getWeekDays } from '../../../../../../../../helpers/date-time';
import { useLang } from '../../../../../../../../hooks/use-lang';
import { useShiftsStore } from '../../../../../../../../store/use-shifts-store';
import s from './shifts-controls-schedule-modal-step-1.module.css';

export const ShiftsControlsScheduleModalStep1 = () => {
  const { t } = useLang();
  const { handleUpdateShift, shift } = useShiftsStore();

  const handleCheck = (index: number) => {
    if (shift?.weekDays?.includes(index)) {
      handleUpdateShift({ weekDays: shift?.weekDays.filter((item) => item !== index) });
    } else {
      handleUpdateShift({ weekDays: [...(shift?.weekDays || []), index] });
    }
  };

  return (
    <div className={s.feature}>
      <h3>{t('Выбрать даты')}</h3>
      <div className={s.range}>
        <DatePicker
          placeholder={t('Период с')}
          name="startDate"
          onSelectDate={(e) => handleUpdateShift({ startDate: e })}
          selectedDate={shift?.startDate}
          className={s.picker}
          minDate={dayjs(new Date()).subtract(1, 'month').toDate()}
          maxDate={dayjs(new Date()).add(3, 'month').toDate()}
        />
        <DatePicker
          placeholder={t('Период по')}
          name="endDate"
          onSelectDate={(e) => handleUpdateShift({ endDate: e })}
          selectedDate={shift?.endDate}
          className={s.picker}
          minDate={dayjs(shift?.startDate).add(1, 'day').toDate()}
          maxDate={dayjs(new Date()).add(3, 'month').toDate()}
        />
      </div>
      <Label label={t('Дни недели')}>
        <ul className={s.weekDays}>
          {getWeekDays('dddd').map((day, index) => (
            <Checkbox
              key={day}
              label={day}
              size="md"
              onClick={() => handleCheck(index)}
              checked={shift?.weekDays?.includes(index)}
            />
          ))}
        </ul>
      </Label>
    </div>
  );
};
